export default "__VITE_ASSET__b162e413__"